import { Outlet, useNavigate } from "react-router-dom";
import { Box, Button, Container, Typography } from "@mui/material";
import { supabase } from "../lib/supabaseClient";

const colors = {
    cream: "#fffaf2",
    paper: "rgba(255, 250, 242, 0.92)",
    ink: "#2a2621",
    muted: "rgba(42, 38, 33, 0.66)",
    brown: "#9b7653",
    brownDark: "#6f5136",
};

function AdminLayout() {
    const navigate = useNavigate();

    async function handleLogout() {
        await supabase.auth.signOut();
        navigate("/admin/login");
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                background:
                    "linear-gradient(180deg, #fffaf2 0%, #f7f1e8 55%, #eef7fa 100%)",
                py: {
                    xs: 3,
                    md: 5,
                },
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: "100%",
                    maxWidth: 1180,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    component="header"
                    sx={{
                        mb: 4,
                        p: {
                            xs: 2,
                            md: 3,
                        },
                        borderRadius: 4,
                        backgroundColor: colors.paper,
                        border: "1px solid rgba(155,118,83,0.15)",
                        boxShadow: "0 18px 60px rgba(78,54,30,0.08)",
                        display: "flex",
                        flexDirection: {
                            xs: "column",
                            sm: "row",
                        },
                        justifyContent: "space-between",
                        alignItems: {
                            xs: "flex-start",
                            sm: "center",
                        },
                        gap: 2,
                    }}
                >
                    <Box>
                        <Typography
                            sx={{
                                fontFamily: '"Nunito Sans", sans-serif',
                                fontSize: 13,
                                fontWeight: 900,
                                letterSpacing: "0.16em",
                                textTransform: "uppercase",
                                color: colors.brown,
                            }}
                        >
                            Hooksieler Lädchen
                        </Typography>

                        <Typography
                            component="h1"
                            sx={{
                                fontFamily: '"Quicksand", sans-serif',
                                fontSize: {
                                    xs: "2rem",
                                    md: "2.6rem",
                                },
                                lineHeight: 1,
                                fontWeight: 700,
                                letterSpacing: "-0.05em",
                                color: colors.ink,
                            }}
                        >
                            Adminbereich
                        </Typography>
                    </Box>

                    <Button
                        onClick={handleLogout}
                        variant="outlined"
                        sx={{
                            borderRadius: 999,
                            borderWidth: 2,
                            borderColor: colors.brown,
                            color: colors.brownDark,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: 13,
                            fontWeight: 900,
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",

                            "&:hover": {
                                borderWidth: 2,
                                borderColor: colors.brownDark,
                                backgroundColor: "rgba(155,118,83,0.08)",
                            },
                        }}
                    >
                        Ausloggen
                    </Button>
                </Box>

                <Outlet />
            </Container>
        </Box>
    );
}

export default AdminLayout;